export default __webpack_public_path__ + "media/images/vid-placeholder-e932b52713f7fadad033877b89bb5513.jpg";